export default {
  "toggle-button": "_toggle-button_wcvmud",
  "accent": "_accent_wcvmud",
  "disabled": "_disabled_wcvmud",
  "label": "_label_wcvmud",
  "toggle-button-grid": "_toggle-button-grid_wcvmud",
  "background": "_background_wcvmud",
  "right": "_right_wcvmud",
  "input": "_input_wcvmud"
};